// src/AudioSpectrum/effects/oscilloscope.js

export const drawOscilloscope = (ctx, timeDomainData, width, height) => {
  ctx.clearRect(0, 0, width, height);
  
  const centerX = width / 2;
  const centerY = height / 2;
  const scale = Math.min(width, height) / 4;
  
  ctx.strokeStyle = '#4CAF50';
  ctx.lineWidth = 2;
  ctx.beginPath();
  
  // 리사주 곡선 스타일로 그리기
  for (let i = 0; i < timeDomainData.length - 1; i += 2) {
    const x1 = timeDomainData[i] / 128.0;
    const y1 = timeDomainData[i + 1] / 128.0;
    
    const x = centerX + x1 * scale;
    const y = centerY + y1 * scale;
    
    if (i === 0) {
      ctx.moveTo(x, y);
    } else {
      ctx.lineTo(x, y);
    }
  }
  
  ctx.stroke();
  
  // 중심점 표시
  ctx.fillStyle = '#4CAF50';
  ctx.beginPath();
  ctx.arc(centerX, centerY, 3, 0, Math.PI * 2);
  ctx.fill();
};